/**
 *
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * http://146.56.218.109:18086/wechat/index.html
 *
 * Copyright 2024-2031 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 */
document.addEventListener('DOMContentLoaded', function () {
    
  let spImgList = [
    'https://cdn.shopify.com/s/files/1/0677/8188/6176/files/20251025-p1.png',
    'https://cdn.shopify.com/s/files/1/0677/8188/6176/files/20251025-p2.png',
    'https://cdn.shopify.com/s/files/1/0677/8188/6176/files/20251025-p1-2.png',
    'https://cdn.shopify.com/s/files/1/0677/8188/6176/files/20251025-p2-2.png',
    'https://cdn.shopify.com/s/files/1/0677/8188/6176/files/20251025-p1-3.png',
    'https://cdn.shopify.com/s/files/1/0677/8188/6176/files/20251025-p2-3.png',

    'https://cdn.shopify.com/s/files/1/0677/8188/6176/files/20251025-a1.png',
    'https://cdn.shopify.com/s/files/1/0677/8188/6176/files/20251025-a2.png',
    'https://cdn.shopify.com/s/files/1/0677/8188/6176/files/20251025-a3.png',
    'https://cdn.shopify.com/s/files/1/0677/8188/6176/files/20251025-a4.png',
  ]
    // 倒计时
  function getRandomNum(min, max) {
    return Math.floor(Math.random() * (max - min)) + min;
  }

  let endTimeG;

  function cutDownTime() {
    let nowTime = new Date();
    let endTime = new Date(endTimeG);

    let leftTime = endTime.getTime() - nowTime.getTime();
    if (leftTime < 0) {
      setupNewCountdown();
      leftTime = 0;
    }
    let leftH = Math.floor((leftTime / (1000 * 60 * 60)) % 24),
      leftM = Math.floor((leftTime / (1000 * 60)) % 60),
      leftS = Math.floor((leftTime / 1000) % 60);
    leftH = leftH >= 10 ? leftH : "0" + leftH;
    leftM = leftM >= 10 ? leftM : "0" + leftM;
    leftS = leftS >= 10 ? leftS : "0" + leftS;

    return {
      hour: leftH,
      minute: leftM,
      second: leftS,
    };
  }
  function setupNewCountdown() {
    const randomHour = getRandomNum(1, 9);
    const currentTime = new Date();
    endTimeG = currentTime.setHours(currentTime.getHours() + randomHour);
  }
  let intervalId;

  function getCutDownTime() {
    setupNewCountdown();
    if (intervalId) clearInterval(intervalId);
    intervalId = setInterval(function () {
      let cutDownTimeText = cutDownTime();
      $(".sp_top_cut_down .sp_left_view .sp_hour").html(cutDownTimeText.hour);
      $(".sp_top_cut_down .sp_left_view .sp_minute").html(
        cutDownTimeText.minute
      );
      $(".sp_top_cut_down .sp_left_view .sp_second").html(
        cutDownTimeText.second
      );
    }, 1000);
  }

  getCutDownTime();

  new Swiper('.sp-swiper-fade', {
    spaceBetween: 10,
    effect: 'fade',
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
      delay: 2000,
    },
    speed: 2000,
  })
  new Swiper('.sp-swiper-fade2', {
    spaceBetween: 10,
    effect: 'fade',
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
      delay: 2000,
    },
    speed: 2000,
  })
    let _swiper = new Swiper(".sp-swiper-pro", {
    speed: 1,
    spaceBetween: 0,
  });
  new Swiper('.sp-swiper-fade1', {
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
    },
    spaceBetween: 10,
    loop: true,
    on: {
      slideChange: function (e) {
        e.slides.find('.sp-text').each(function () {
          this.style.animation = 'none'
        })
        const spText = e.slides.eq(e.activeIndex).find('.sp-text')[0]
        if (spText) {
          spText.style.animation = 'none'

          spText.style.animation = `swiper-up-fade 0.5s ease forwards`
        }
      },
    },
  })

  new Swiper('.sp-swiper-scroll1', {
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
      delay: 0,
    },
    slidesPerView: 'auto',
    speed: 4000,
    loop: true,
    spaceBetween: 20,
  })

  jQuery('.sp-scroll').slide({
    mainCell: '.nav-imgs',
    autoPlay: true,
    effect: 'leftMarquee',
    interTime: 12,
    vis: 1,
    scroll: 1,
  })
  jQuery('.sp-scroll2').slide({
    mainCell: '.nav-imgs',
    autoPlay: true,
    effect: 'leftMarquee',
    interTime: 12,
    vis: 1,
    scroll: 1,
  })
  new Swiper('.sp-swiper1', {
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
    },
    spaceBetween: 0,
    loop: true,
  })

  new Swiper('.sp-part6 .sp-swiper1', {
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
    },
    spaceBetween: 0,
    loop: true,
  })

  // Part5 Ingredients Swiper (Mobile)
  new Swiper('.sp-part5 .sp-swiper1', {
    slidesPerView: 2,
    spaceBetween: 32,
    loop: true,
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
  })

  // Part6 Steps Swiper (Mobile)
  new Swiper('.sp-steps-swiper', {
    slidesPerView: 3,
    spaceBetween: 20,
    loop: true,
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
  })

  // Part3 Before/After Swiper (PC)
  new Swiper('.sp-part3-swiper', {
    slidesPerView: 1,
    spaceBetween: 20,
    loop: true,
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
    navigation: {
      nextEl: '.sp-part3-next',
      prevEl: '.sp-part3-prev',
    },
    pagination: {
      el: '.sp-part3-pagination',
      clickable: true,
    },
  })

  // new Swiper(".sp-swiper2", {
  //   autoplay: true,
  //   autoplay: {
  //     disableOnInteraction: false,
  //   },
  //   spaceBetween: 20,
  //   loop: true,
  // });
  // new Swiper(".sp-swiper22", {
  //   autoplay: true,
  //   autoplay: {
  //     disableOnInteraction: false,
  //   },

  //   spaceBetween: 20,

  //   loop: true,
  // });

  $(" .sp-option").click(function () {
    $(this).siblings().removeClass("active");
    $(this).addClass("active");

    let colorOptions = $(" .sp-color .sp-option.active").index();
let size = $(" .sp-size .sp-option.active").index();
    _index = colorOptions +size *2
    changePrice()
    // $(".sp_product_part.sp_mobile .sp-img-p")
    //   .eq(_index)
    //   .addClass("active")
    //   .siblings()
    //   .removeClass("active");

    _swiper.slideToLoop(_index);
  });
   
  function mainRender() {
    $(function () {
      $('#root').css('zoom', 'normal')
      if (document.body.clientWidth <= 1060) {
        let scale = document.body.clientWidth / 1080
        $('#root').css('zoom', scale)
      } else {
        const scale = document.body.clientWidth / 1920
        $('#root').css('zoom', scale)
      }

      window.addEventListener(
        'resize',
        (function () {
          var timer
          return function () {
            if (timer) clearTimeout(timer)
            timer = setTimeout(function () {
              $('#root').css('zoom', 'normal')
              if (document.body.clientWidth <= 1060) {
                let scale = document.body.clientWidth / 1080
                $('#root').css('zoom', scale)
              } else {
                const scale = document.body.clientWidth / 1920
                $('#root').css('zoom', scale)
              }
            }, 100)
          }
        })()
      )
    })

    function lazyLoadImages() {
      // 懒加载
      const images = document.querySelectorAll('.lazy-load') // 获取所有需要懒加载的图片
      const config = {
        rootMargin: '0px 0px 1300px 0px',
        threshold: 0,
      }

      const lazyLoadObserver = new IntersectionObserver(function (
        entries,
        observer
      ) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            // 当图片进入视口时
            const image = entry.target
            const dataSrc = image.getAttribute('data-src')
            image.src = dataSrc // 将data-src属性的值设置为图片的实际地址
            lazyLoadObserver.unobserve(image) // 停止观察该图片
          }
        })
      },
      config)

      images.forEach(function (image) {
        lazyLoadObserver.observe(image) // 开始观察每个图片
      })
    }

    function preloadImages(imageArray) {
      // 预加载
      // 检查数组数据结构
      if (Array.isArray(imageArray[0])) {
        // 处理二维数组
        imageArray.forEach(subArray => {
          subArray.forEach(url => {
            const img = new Image()
            img.src = url
          })
        })
      } else {
        // 处理一维数组
        imageArray.forEach(url => {
          const img = new Image()
          img.src = url
        })
      }
    }

    lazyLoadImages()

    preloadImages(spImgList)

    // 找到所有跳转套餐的锚点链接
    var links = document.querySelectorAll('a[href^="#shopping"]')
    links.forEach(function (link) {
      link.addEventListener('click', function (event) {
        event.preventDefault() // 阻止默认的跳转行为
        // 方式一
        const targetElement = document.getElementById('shopping') // 获取跳转目标节点
        const offsetTop = targetElement.offsetTop
        let sptop = document.body.clientWidth <= 1080 ? 72 : 34

        window.scroll({
          top:
            offsetTop * $('div#root').css('zoom') -
            sptop * $('div#root').css('zoom'),
          behavior: 'smooth', // 使用 smooth 实现平滑滚动
        })
      })
    })

    // IOS字体多了间距的处理 给节点添加 sp_system 类名
    // 判断当前用户是安卓端还是iOS端
    var userAgent = navigator.userAgent || navigator.vendor || window.opera
    var isAndroid = /android/i.test(userAgent)
    var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream
    var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent) // 添加了对 "Iron" 关键词的判断

    if (isAndroid) {
      console.log('Android')
    } else if (isIOS) {
      console.log('iOS')
    } else if (isPC) {
      console.log('PC')
    } else {
      $('.sp_system').css('letter-spacing', '-4px')
    }
  }
  
  mainRender()
 let prods = window.product
    function getCur(){
      let color = $('#sp-color div.active').attr('data-val')
      let size = $('#sp-size div.active').attr('data-val')
      return prods.filter(item=> item.option1 == color&&item.option2 == size)[0]
    }
    function changePrice(){
      let num = $('#calcNumber').val()
      let price = (getCur().price * num / 100).toFixed(2)
      let compare = (getCur().compare_at_price * num / 100).toFixed(2)
      price = (price + '').replace('.', ',')
      compare = (compare + '').replace('.', ',')
      $('#sp_price1').html(price)
      $('#sp_price2').html(compare)
      let off_font = 100 - Math.ceil(getCur().price / getCur().compare_at_price * 100)
      
      $(".sp_product_part .sp-p .sp-percent").html(`${off_font}`)

    }
    $('.sp-btn-style').click(function(){
      let num = $('#calcNumber').val()
      window.location.href = '/cart/' + getCur().id + ':' + num
    })
  
    
  $(".sp-reduce").click(function () {
    let input = $(this).siblings("input")[0];
    let num = Number(input.value) - 1;
    if (num > 0) {
      input.value = num;
    }
    changePrice()
  });
  $(".sp-add").click(function () {
    let input = $(this).siblings("input")[0];
    let num = Number(input.value) + 1;
    input.value = num;
   changePrice()
  });

  // 标题文本渐出
  const graduallyList = document.getElementsByClassName('gradually')
  for (let gradually of graduallyList) {
    const spans = gradually.querySelectorAll('span')
    const paragraph = gradually.querySelector('.sp-sub-title')

    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            // 给每个 span 和 i 动画
            spans.forEach((span, index) => {
              span.style.animation = `swift-up-fade 0.5s ease forwards`
              span.style.animationDelay = `${index * 0.1}s`

              const i = span.querySelector('i')
              if (i) {
                i.style.animation = `swift-up-fade 0.5s ease forwards`
                i.style.animationDelay = `${index * 0.1}s`
              }
            })

            // 段落
            const totalDelay = spans.length * 0.1 + 0.3
            if (paragraph) {
              paragraph.style.animation = `swift-up-fade 0.5s ease forwards`
              paragraph.style.animationDelay = `${totalDelay}s`
            }

            observer.unobserve(gradually)
          }
        })
      },
      {
        threshold: 0.3,
      }
    )
    observer.observe(gradually)
  }

  // 产品切换
  $('.sp-mobile .sp-product-btn').click(function () {
    $(this).addClass('active').siblings().removeClass('active')
    let _index = $(this).index()
    $('.sp-mobile .sp-product-inner')
      .eq(_index)
      .addClass('active')
      .siblings()
      .removeClass('active')
  })
  // 产品切换-pc
  $('.sp-pc .sp-product-btn').click(function () {
    $(this).addClass('active').siblings().removeClass('active')
    let _index = $(this).index()
    $('.sp-pc .sp-product-inner')
      .eq(_index)
      .addClass('active')
      .siblings()
      .removeClass('active')
  })

  // // 点击按钮
  // $(".sp-video-btn").click(function () {
  //   $(".sp-mask").css("display", "flex");
  // });
  // // 关闭弹窗按钮

  // $(".sp-mask").click(function (e) {
  //   if ($(e.target).closest(".sp-mask video").length > 0) {
  //   } else {
  //     $(".sp-mask").hide();
  //   }
  // });

  // 菜单
  $('.sp-menu-btn').click(function (e) {
    $('.sp-menu-mask').show()
  })

  $('.sp-menu-mask').click(function (e) {
    // if ($(e.target).closest(".sp-menu-mask li").length > 0) {
    // } else {
    $('.sp-menu-mask').hide()
    // }
  })

  // 滚动隐藏顶部
  if (
    $(window).scrollTop() >
    $('.sp-header').height() * $('div#root').css('zoom')
  ) {
    $('.header-bottom').addClass('sp-fixed')
  } else {
    $('.header-bottom').removeClass('sp-fixed')
  }

  $(window).scroll(function () {
    if (
      $(window).scrollTop() >
      $('.sp-header').height() * $('div#root').css('zoom')
    ) {
      $('.header-bottom').addClass('sp-fixed')
    } else {
      $('.header-bottom').removeClass('sp-fixed')
    }
  })

  // 问答
  $('.q-row').click(function () {
    $(this).parent().toggleClass('sp-show')
  })
    let initNum = 0;
  $(document).on("click", ".sp_add_cart", function () {
    // 购物车加购动效

    $(this).children("img").addClass("on");
    $(".sp-cart .num").show();
    setTimeout(function () {
      $(" .cart-btn").children("img").removeClass("on");
    }, 500);
    $(" .sp-cart").addClass("on");
    setTimeout(function () {
      $(".sp-cart").removeClass("on");
    }, 500);


    // $("#calcNumber").val(1);

    
    var data = {
        id: getCur().id,
        quantity: $('#calcNumber').val(),
      };
      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: data,
        success: function () {
          $.getJSON(window.Shopify.routes.root + "cart.js", function (result) {
            $(".cardNum").each(function () {
                $(this).html(result.item_count);
            });
          });
        },
        dataType: "json",
      });
    $(".cardNum").removeClass("sp-gray");
    // handleAddToCart(initNum);

    var imgs = $(".sp_product_part .swiper-slide-active").find("img");
    // var imgs = $(".sp_product_part .sp-img-p.active");

    imgs.each(function () {
      var $img = $(this);
      var flyer = $img[0].cloneNode(true);
      flyer.classList.add("sp_clone");

      $(".sp_product_part").append(flyer);
      $(flyer).css({
        width: $img[0].width,
        height: $img[0].height,
        background: "#e7e9ef",
        position: "fixed",

        top: $img[0].offsetTop,
        left: $img.offset().left,
        "z-index": 99,
      });
      let finish;
      if (document.body.clientWidth <= 1080) {
        finish = $(".sp-btn-style2 .sp-cart");

        $(flyer).animate(
          {
            top: $(".sp-btn-style2")[0].offsetTop,
            left:
              $(".sp-btn-style2 .sp-area2")[0].offsetLeft + finish.width() / 2,
            width: 50,
            height: 50,
            opacity: 0.4,
          },
          500,
          "linear",
          function () {
            $(this).animate(
              {
                width: 0,
                height: 0,
                opacity: 0,
              },
              0,
              function () {
                $(this).detach();
              }
            );
          }
        );
      } else {
        finish = $(".header-inner .sp-cart");
        console.log(finish[0].top,"finish.offsetTop")
        console.log(finish,"finish.offsetTop")
        $(flyer).animate(
          {
            top: finish[1].offsetTop,
            left: finish[1].offsetLeft + finish.width() / 2,
            width: 50,
            height: 50,
            opacity: 0.4,
          },
          500,
          "linear",
          function () {
            $(this).animate(
              {
                width: 0,
                height: 0,
                opacity: 0,
              },
              0,
              function () {
                $(this).detach();
              }
            );
          }
        );
      }
    });
  });
  // 文本渐出动画
  const graduallyList2 = document.getElementsByClassName('sp-fade-box')
  for (let gradually2 of graduallyList2) {
    const paragraph2 = gradually2.querySelectorAll('.sp-ani')

    const observerAni = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            paragraph2.forEach((span, index) => {
              span.style.animation = `sp-fade-in 1s ease forwards`
              span.style.animationDelay = `${index * 0.5 + 0.5}s`
            })

            observerAni.unobserve(gradually2)
          }
        })
      },
      {
        threshold: 0.3,
      }
    )
    observerAni.observe(gradually2)
  }

  // 文本渐出动画
  const graduallyList3 = document.getElementsByClassName('sp-fade-box2')
  for (let gradually3 of graduallyList3) {
    const paragraph3 = gradually3.querySelectorAll('.sp-ani2')

    const observerAni = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            paragraph3.forEach((span, index) => {
              span.style.animation = `sp-fade-left 1s ease forwards`
              span.style.animationDelay = `${index * 0.3 + 1}s`
            })

            observerAni.unobserve(gradually3)
          }
        })
      },
      {
        threshold: 0.3,
      }
    )
    observerAni.observe(gradually3)
  }

  // 手风琴交互逻辑 (新增)
  $('.sp-qa1-faq-question').on('click', function () {
    var $currentItem = $(this).parent('.sp-qa1-faq-item')
    var $answer = $(this).next('.sp-qa1-faq-answer')
    var $icon = $(this).find('.sp-qa1-faq-icon')

    if ($currentItem.hasClass('active')) {
      $answer.slideUp()
      $currentItem.removeClass('active')
      $icon.removeClass('fa-minus').addClass('fa-plus')
    } else {
      $('.sp-qa1-faq-item').removeClass('active')
      $('.sp-qa1-faq-answer').slideUp()
      $('.sp-qa1-faq-icon').removeClass('fa-minus').addClass('fa-plus')

      $currentItem.addClass('active')
      $answer.slideDown()
      $icon.removeClass('fa-plus').addClass('fa-minus')
    }
  })

  // Part3 Before/After Slider (PC)
  ;(function () {
    const sliderWrap = document.querySelector(
      '.sp-part3.sp-pc .sp-comparison-slider'
    )
    if (!sliderWrap) return

    const slides = sliderWrap.querySelectorAll('.sp-comparison-slide')
    const dots = document.querySelectorAll('.sp-part3.sp-pc .sp-dot')
    const prevBtn = document.querySelector('.sp-part3.sp-pc .sp-slider-prev')
    const nextBtn = document.querySelector('.sp-part3.sp-pc .sp-slider-next')
    let currentIndex = 0
    let autoPlayTimer = null

    function showSlide(index) {
      if (index >= slides.length) index = 0
      if (index < 0) index = slides.length - 1
      currentIndex = index

      slides.forEach((slide, i) => {
        slide.classList.toggle('active', i === currentIndex)
      })
      dots.forEach((dot, i) => {
        dot.classList.toggle('active', i === currentIndex)
      })
    }

    function nextSlide() {
      showSlide(currentIndex + 1)
    }

    function prevSlide() {
      showSlide(currentIndex - 1)
    }

    function startAutoPlay() {
      stopAutoPlay()
      autoPlayTimer = setInterval(nextSlide, 3000)
    }

    function stopAutoPlay() {
      if (autoPlayTimer) {
        clearInterval(autoPlayTimer)
        autoPlayTimer = null
      }
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        prevSlide()
        startAutoPlay()
      })
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        nextSlide()
        startAutoPlay()
      })
    }

    dots.forEach((dot, index) => {
      dot.addEventListener('click', function () {
        showSlide(index)
        startAutoPlay()
      })
    })

    startAutoPlay()
  })()
})
